import {
  useEffect,
  useState,
} from "react";

import {
  getOfferingOverview,
} from "../../../api/offering-overview/offeringOverview.api";


const useProductOverview = (slug) => {

  const [overview, setOverview] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);


  useEffect(() => {

    if (!slug) {

      setOverview(null);

      setError("Offering slug is required");

      setLoading(false);

      return;
    }


    const fetchOverview = async () => {

      try {

        setLoading(true);

        setError(null);

        setOverview(null);


        const response =
          await getOfferingOverview(slug);


        /*
        |--------------------------------------------------------------------------
        | Backend response
        |--------------------------------------------------------------------------
        |
        | {
        |   success: true,
        |   message: "...",
        |   data: {
        |     ...
        |   }
        | }
        |
        */

        setOverview(
          response?.data || null
        );

      } catch (err) {

        console.error(
          "Failed to fetch offering overview:",
          err
        );


        const message =
          err.response?.data?.message ||
          "Unable to load offering information.";


        setError(message);

        setOverview(null);

      } finally {

        setLoading(false);

      }

    };


    fetchOverview();


  }, [slug]);


  return {
    overview,
    loading,
    error,
  };

};


export default useProductOverview;